import { gql } from '@apollo/client';

export const ContinuityProviderFields = gql`
  fragment ContinuityProviderFields on ContinuityProvider {
    id
    costModel
    confirmedAt
    contactEmail
    description
    monthlyCost
    platform
    status
    updatedAt
    policy {
      confirm
      remove
      update
    }
    role
  }
`;
